export const proxy = "https://reporting-backend.gate-internet.de";
